import { GeoZoneViewInfo, PatrolTimeForecast } from '@EcamModel/model/CameraView';

function formatGracePeriods(geoZones: GeoZoneViewInfo[] = []): string {
    const groups: Record<string, { grace: number; views: string[] }> = {};

    geoZones.forEach((z) => {
        const grace = Number(z.GracePeriod ?? 0);
        const key = String(grace);

        if (!groups[key]) {
            groups[key] = { grace, views: [] };
        }
        const name = (z.ViewName || '').trim();
        if (name && !groups[key].views.includes(name)) {
            groups[key].views.push(name);
        }
    });

    const parts = Object.values(groups)
        .sort((a, b) => a.grace - b.grace)
        .map((g) => `${g.grace}s (${g.views.join(', ')})`);

    return parts.join(', ');
}

export function buildPatrolSummary(patrolTimeForecast: PatrolTimeForecast): string {
    const secs = Number(patrolTimeForecast.TimeForecast ?? 0);
    const grace = formatGracePeriods(patrolTimeForecast.GeoZoneViewInfo || []);
    return `The estimated patrol time is ${secs}s; Grace periods: ${grace}.`;
}
